export default __webpack_public_path__ + "static/media/s6.36e45e24.jpg";